export default __webpack_public_path__ + "static/media/pm.46b2b172.PNG";